import angular from 'angular';
import { AppConfigProvider } from './AppConfig';
import { AppDataProvider } from './AppData';
import { AppServicesProvider } from './AppServices';
import { AppToolsProvider } from './AppTools';
import { SetupServicesProvider } from './SetupServices';
import { outStandingBankItemConfig } from './Data/OutstandingBankItem';
import { setupAccountConfig } from './Data/SetupAccount';
import { setupBankAccountConfig } from './Data/SetupBankAccount';
import { setupDataConfig } from './Data/SetupData';
import { setupJournalConfig } from './Data/SetupJournal';
import { setupJournalItemConfig } from './Data/SetupJournalItem';
import { accountInfoConfig } from './Data/books/AccountInfo';
import { accountTypeConfig } from './Data/books/AccountType';
import { addressConfig } from './Data/books/Address';
import { classInfoConfig } from './Data/books/ClassInfo';
import { entityInfoConfig } from './Data/books/EntityInfo';
import { fundraiserConfig } from './Data/books/Fundraiser';
import { journalItemConfig } from './Data/books/JournalItem';
import { accountAdminInfoConfig } from './Data/books/accounts/AccountAdminInfo';
import { organizationConfig } from './Data/books/entities/Organization';

export default angular
  .module('csm.books.InitialSetup.services', [])
  .provider('AppConfig', AppConfigProvider)
  .provider('AppData', AppDataProvider)
  .provider('AppServices', AppServicesProvider)
  .provider('AppTools', AppToolsProvider)
  .provider('SetupServices', SetupServicesProvider)
  .config(outStandingBankItemConfig)
  .config(setupAccountConfig)
  .config(setupBankAccountConfig)
  .config(setupDataConfig)
  .config(setupJournalConfig)
  .config(setupJournalItemConfig)
  .config(accountInfoConfig)
  .config(accountTypeConfig)
  .config(addressConfig)
  .config(classInfoConfig)
  .config(entityInfoConfig)
  .config(fundraiserConfig)
  .config(journalItemConfig)
  .config(accountAdminInfoConfig)
  .config(organizationConfig).name;
